import React, { ReactElement } from 'react';

type SparkleIconProps = {
  size?: number;
  color?: string;
  className?: string;
};

const SparkleIcon = ({
  size = 170,
  color = '#1C2A46',
  className,
}: SparkleIconProps): ReactElement => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height={size}
    viewBox="0 0 170 170"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M84 0L107 61L168 85L107 109L84 170L61 109L0 85L61 61L84 0Z" fill={color} />
  </svg>
);

export default SparkleIcon;
